// extracted by mini-css-extract-plugin
export default {"icon":"Signature_icon__tOXoV"};